import { render, staticRenderFns } from "./cancelled-orders-chart.vue?vue&type=template&id=22f5b4c4&scoped=true&"
import script from "./cancelled-orders-chart.vue?vue&type=script&lang=js&"
export * from "./cancelled-orders-chart.vue?vue&type=script&lang=js&"
import style0 from "./cancelled-orders-chart.vue?vue&type=style&index=0&id=22f5b4c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f5b4c4",
  null
  
)

export default component.exports